import { createContext, useContext } from "react";
import { StoreReviewsProps } from "~/components/admin/store/StoreReviews";
import { Product, StoreAddress } from "~/lib/types";
import type { PublicStoreProfileRow } from "~/lib/public_store_profiles";

interface StoreContextProps {
  storeDetails: PublicStoreProfileRow;
  storeProducts: Product[];
  storeReviews: StoreReviewsProps[];
  storeAddress?: StoreAddress | null;
  featuredProducts: Product[];
}

export const StoreContext = createContext<StoreContextProps | null>(null);

export function useStoreContext() {
  const storeContext = useContext(StoreContext);

  if (!storeContext) {
    throw new Error(
      "Store context is not available. Make sure to wrap your component with StoreContext.Provider."
    );
  }
  return storeContext;
}
